import React, { useState } from 'react';
import { FaGooglePlay, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const CineMovie = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <div className="min-h-screen bg-gray-900">
      {/* IM Logo */}

    <a
    href="/"
    className="fixed top-4 left-4 sm:top-6 sm:left-6 md:top-8 md:left-8 lg:top-10 lg:left-24 z-50
             text-2xl sm:text-3xl md:text-4xl font-bold
             bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent
             hover:from-purple-500 hover:to-blue-400 transition-all duration-200"
    >
    IM
    </a>

      {/* Hero Section with Modern Layout */}
      <div className="relative min-h-screen">
        {/* Background with overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url("/cinemovie.png")',
            backgroundAttachment: 'fixed'
          }}
        />

        {/* Content Grid */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Text Content */}
            <div className="pt-20 lg:pt-0">
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
                Talk, Discover, and Watch –
                <span className="text-red-500"> All with CineMovie</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl">
                Control your movie experience with voice commands. Browse, search, and discover movies hands-free with our innovative app.
              </p>
              <a
                href="https://play.google.com/store/apps/details?id=com.imranmelikov.cinemovie"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-all duration-300 transform hover:scale-105 w-fit shadow-lg hover:shadow-red-500/30"
              >
                <FaGooglePlay className="mr-2 text-xl" />
                Download on Play Store
              </a>
            </div>

            {/* Right Column - Feature Cards */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 relative">
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300">
                    <h3 className="text-xl font-semibold text-white mb-3">Voice Control</h3>
                    <p className="text-gray-300">Navigate through movies using just your voice commands</p>
                  </div>
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300 lg:mt-12">
                    <h3 className="text-xl font-semibold text-white mb-3">Smart Search</h3>
                    <p className="text-gray-300">Find movies instantly with intelligent search features</p>
                  </div>
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300">
                    <h3 className="text-xl font-semibold text-white mb-3">Personalized</h3>
                    <p className="text-gray-300">Get recommendations based on your preferences</p>
                  </div>
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300 lg:mt-12">
                    <h3 className="text-xl font-semibold text-white mb-3">Smart Library</h3>
                    <p className="text-gray-300">Manage your favorites, plan your watchlist, and revisit your watched titles anytime</p>
                  </div>
                </div>
          </div>
        </div>

        {/* Privacy Policy Section with Modern Styling */}
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-gray-800/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => setShowPrivacy(!showPrivacy)}
            >
              <h2 className="text-2xl font-bold text-white">Privacy Policy</h2>
              {showPrivacy ? (
                <FaChevronUp className="text-white text-xl" />
              ) : (
                <FaChevronDown className="text-white text-xl" />
              )}
            </div>

            {showPrivacy && (
              <div className="mt-6 text-gray-300 space-y-6 prose prose-invert max-w-none">
                <p className="text-sm text-gray-400">Last updated: April 18, 2025</p>

                <p>
                  This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
                </p>

                <h3 className="text-xl font-semibold text-white">Information We Collect</h3>
                <p>When you use CineMovie, we may collect and store the following information through Firebase services:</p>
                <ul className="list-disc pl-6">
                  <li>Name and Surname (via Google Sign-In)</li>
                  <li>Email address (via Google Sign-In)</li>
                  <li>Profile photo (optional, chosen via gallery without requiring explicit storage permissions)</li>
                  <li>Voice input permissions (to use voice features within the app)</li>
                </ul>

                <h3 className="text-xl font-semibold text-white">How We Use Your Information</h3>
                <p>We use the collected information for the following purposes:</p>
                <ul className="list-disc pl-6">
                  <li>To allow authentication and personalized access through Google Sign-In</li>
                  <li>To display your name and profile picture within the app</li>
                  <li>To enable features such as saving to favorites, watch later list, watched list</li>
                  <li>To support voice interaction features</li>
                  <li>To enhance user experience by fetching data from third-party APIs (TMDB and YouTube)</li>
                </ul>

                <h3 className="text-xl font-semibold text-white">Delete Your Personal Data</h3>
                <p>
                  You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
                  Our Service may give You the ability to delete certain information about You from within the Service.
                </p>
                <p>
                  You may update, amend, or delete Your information at any time by signing in to Your Account and visiting the account settings section.
                  You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.
                </p>

                <h3 className="text-xl font-semibold text-white">Third-party Services</h3>
                <p>We use the following third-party services which may collect information used to identify you:</p>
                <ul className="list-disc pl-6">
                  <li>Firebase Authentication, Firestore, and Firebase Storage (<a href="https://firebase.google.com/support/privacy" className="text-primary hover:text-primary/80">Google Privacy Policy</a>)</li>
                  <li>TMDB API (<a href="https://www.themoviedb.org/documentation/api/terms-of-use" className="text-primary hover:text-primary/80">Terms of Use</a>)</li>
                  <li>YouTube API (<a href="https://developers.google.com/youtube/terms/api-services-terms-of-service" className="text-primary hover:text-primary/80">Terms of Service</a>)</li>
                </ul>

                <h3 className="text-xl font-semibold text-white">Data Security</h3>
                <p>
                  We value your trust in providing us your Personal Information, thus we strive to use commercially acceptable means of protecting it.
                  However, no method of transmission over the internet, or method of electronic storage is 100% secure and reliable.
                </p>

                <h3 className="text-xl font-semibold text-white">Children's Privacy</h3>
                <p>
                  Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13.
                  If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us.
                </p>

                <h3 className="text-xl font-semibold text-white">Your Rights</h3>
                <p>Depending on your location, you may have the right to:</p>
                <ul className="list-disc pl-6">
                  <li>Access the personal data we hold about you</li>
                  <li>Request correction or deletion of your personal data</li>
                  <li>Object to or restrict certain processing of your data</li>
                </ul>
                <p>To exercise these rights, please contact us at: imran.melikov84@gmail.com</p>

                <h3 className="text-xl font-semibold text-white">How to Delete Your Account</h3>
                <p>
                  To delete your account and all related data:
                  Open the CineMovie app → Go to your Profile → Select "Delete Account"
                </p>

                <h3 className="text-xl font-semibold text-white">Contact Us</h3>
                <p>
                  If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at:
                  <a href="mailto:imran.melikov84@gmail.com" className="text-primary hover:text-primary/80 ml-1">
                    imran.melikov84@gmail.com
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CineMovie;